import React from "react";
import { useHistory } from "react-router";
import DriversTable from "./components/DriversTable";
import useSetState from "../../hooks/useSetState";
import BaseLayout from "../../components/layouts/BaseLayout";

const Drivers: React.FC = () => {
  const history = useHistory();
  const [{ deleteOpen, driverToDelete, idToDelete }, setState] = useSetState({
    deleteOpen: false,
    driverToDelete: "",
    idToDelete: "",
    editId: "",
  });

  const toggleDeletePopup = (e, row): void => {
    setState({
      deleteOpen: !deleteOpen,
      driverToDelete: row.name,
      idToDelete: row.id,
    });
  };

  const handleEdit = (row): void => {
    setState({ editId: row });
    history.push(`/admin/drivers/${row.id}`);
  };
  const handleAddDriver = () => history.push("/admin/drivers/create");

  return (
    <BaseLayout title="Drivers">
      <DriversTable
        ctaText="New Driver"
        handleEditClick={handleEdit}
        handleAddVehicle={handleAddDriver}
        handleDeleteClick={toggleDeletePopup}
        deletePopupOpen={deleteOpen}
        driverToDelete={driverToDelete}
        idToDelete={idToDelete}
      />
    </BaseLayout>
  );
};

export default Drivers;
